export const colorsMap = {
  '#19783C': 'var(--chart-green)',
  '#4646AA': 'var(--chart-blue)',
  '#509128': 'var(--chart-green)',
  '#6496C3': 'var(--chart-indigo)',
  '#64C3B4': 'var(--chart-teal)',
  '#8C960F': 'var(--chart-green)',
  '#A05F28': 'var(--chart-orange)',
  '#A53CAA': 'var(--chart-pink)',
  '#C36496': 'var(--chart-pink)',
  '#DC5A32': 'var(--chart-red)',
  '#DCA541': 'var(--chart-orange)',
  '#DCDC50': 'var(--chart-yellow)',
}

const defaultColor = 'var(--chart-blue)'
export function getMappedColor(color: string) {
  return color
    ? colorsMap[color as keyof typeof colorsMap] || color
    : defaultColor
}

export function getMappedColors(colors: string[] | undefined) {
  return (colors || []).map((color) => getMappedColor(color))
}
